import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

const OwnerCredentialsModal = ({ show, onClose }) => {
  const { user, token } = useAuth();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newUsername, setNewUsername] = useState(user?.username || '');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  if (!show) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!currentPassword) {
      setError('Current password is required');
      return;
    }

    if (newPassword && newPassword !== confirmPassword) {
      setError('New passwords do not match');
      return;
    }

    setSubmitting(true);
    try {
      const response = await fetch('/api/auth/owner/change-credentials', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
          // Include multi-tenant identifiers in body as well if needed by rules
        },
        body: JSON.stringify({
          currentPassword,
          newUsername: newUsername && newUsername !== user?.username ? newUsername : undefined,
          newPassword: newPassword || undefined,
          ownerId: user?.ownerId,
          staffId: user?.staffId
        })
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Failed to update credentials');
      }

      // Update stored token so the app reflects new username
      if (data.token) {
        localStorage.setItem('token', data.token);
      }

      setSuccess('Credentials updated successfully');
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
      // Close after short delay
      setTimeout(() => {
        onClose?.();
        window.location.reload();
      }, 800);
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="modal d-block" tabIndex="-1" role="dialog" style={{ background: 'rgba(0,0,0,0.5)' }} onClick={onClose}>
      <div className="modal-dialog" role="document" onClick={(e) => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Login/parolni o'zgartirish</h5>
            <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              {error && <div className="alert alert-danger" role="alert">{error}</div>}
              {success && <div className="alert alert-success" role="alert">{success}</div>}

              <div className="mb-3">
                <label className="form-label">Hozirgi parol</label>
                <input type="password" className="form-control" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} required />
              </div>

              <div className="mb-3">
                <label className="form-label">Username (Foydalanuvchi nomi)</label>
                <input type="text" className="form-control" value={newUsername} onChange={(e) => setNewUsername(e.target.value)} placeholder="O'zgartirmasangiz bo'sh qoldiring" />
              </div>

              <div className="mb-3">
                <label className="form-label">Yangi parol</label>
                <input type="password" className="form-control" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} placeholder="Parolni o'zgartirmasangiz bo'sh qoldiring" />
              </div>

              <div className="mb-3">
                <label className="form-label">Yangi parolni takrorlang</label>
                <input type="password" className="form-control" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} placeholder="Parolni takrorlang" />
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={onClose} disabled={submitting}>Yopish</button>
              <button type="submit" className="btn btn-success" disabled={submitting}>
                {submitting ? 'Saqlanmoqda...' : 'Saqlash'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default OwnerCredentialsModal;


